export default __webpack_public_path__ + "static/media/diners.10e38ce8.svg";